import type { IconType } from "@src/appV2/redesign/system/ui-components";

import { JobType, ShiftNameType } from "./types";

export const jobTypeOptions = [
  { label: "Full time", value: JobType.FULL_TIME },
  { label: "Part time", value: JobType.PART_TIME },
  { label: "PRN", value: JobType.PER_DIEM },
];

export const shiftTypeOptions: Array<{
  label: string;
  value: ShiftNameType;
  icon: IconType;
  iconOutlined: IconType;
}> = [
  { label: "Day", value: ShiftNameType.AM, icon: "sun-filled", iconOutlined: "sun-outlined" },
  {
    label: "Evening",
    value: ShiftNameType.PM,
    icon: "sunset-filled",
    iconOutlined: "sunset-outlined",
  },
  {
    label: "Overnight",
    value: ShiftNameType.NOC,
    icon: "moon-filled",
    iconOutlined: "moon-outlined",
  },
];

// Default filter values for placement filters
export const defaultJobTypes = jobTypeOptions.map((o) => o.value).join(",");
export const defaultShiftTypes = shiftTypeOptions.map((o) => o.value).join(",");
export const defaultDaysOfWeek = "MONDAY,TUESDAY,WEDNESDAY,THURSDAY,FRIDAY|SATURDAY,SUNDAY";
export const defaultAgeGroups = "";

export function areCommaSeparatedSetsEqual(a?: string, b?: string, delimiter = ","): boolean {
  const toSet = (value?: string) => new Set((value ?? "").split(delimiter).filter(Boolean));
  const setA = toSet(a);
  const setB = toSet(b);

  if (setA.size !== setB.size) {
    return false;
  }

  for (const item of setA) {
    if (!setB.has(item)) {
      return false;
    }
  }

  return true;
}
